export default __webpack_public_path__ + "static/media/gChurchil.3fc4f78d.png";